// Types of action for requesting last winners
export const REQUEST_LAST_WINNERS = 'REQUEST_LAST_WINNERS';
export const REQUEST_LAST_WINNERS_PENDING = 'REQUEST_LAST_WINNERS_PENDING';
export const REQUEST_LAST_WINNERS_SUCCESS = 'REQUEST_LAST_WINNERS_SUCCESS';
export const REQUEST_LAST_WINNERS_ERROR = 'REQUEST_LAST_WINNERS_ERROR';